export default {
  "pages.layouts.userLayout.title":
    "Ant Design 是西湖區最具影響力的 Web 設計規範",
  "pages.login.accountLogin.tab": "賬戶密碼登錄",
  "pages.login.accountLogin.errorMessage":
    "錯誤的用戶名和密碼(admin/ant.design)",
  "pages.login.failure": "登錄失敗，請重試！",
  "pages.login.success": "登錄成功！",
  "pages.login.username.placeholder": "用戶名: admin or user",
  "pages.login.username.required": "用戶名是必填項！",
  "pages.login.password.placeholder": "密碼: ant.design",
  "pages.login.password.required": "密碼是必填項！",
  "pages.login.phoneLogin.tab": "手機號登錄",
  "pages.login.phoneLogin.errorMessage": "驗證碼錯誤",
  "pages.login.phoneNumber.placeholder": "請輸入手機號！",
  "pages.login.phoneNumber.required": "手機號是必填項！",
  "pages.login.phoneNumber.invalid": "不合法的手機號！",
  "pages.login.captcha.placeholder": "請輸入驗證碼！",
  "pages.login.captcha.required": "驗證碼是必填項！",
  "pages.login.phoneLogin.getVerificationCode": "獲取驗證碼",
  "pages.getCaptchaSecondText": "秒後重新獲取",
  "pages.login.rememberMe": "自動登錄",
  "pages.login.forgotPassword": "忘記密碼 ?",
  "pages.login.submit": "登錄",
  "pages.login.loginWith": "其他登錄方式 :",
  "pages.login.registerAccount": "註冊賬戶",
  "pages.login.logo.title": "No.1 Hoops",
  "pages.login.logo.subtitle": "管理系統",
  "pages.login.loginType.email": "郵箱登錄",
  "pages.login.loginType.phone": "手機號登錄",
  "pages.login.loginType.emailLabel": "郵箱",
  "pages.login.loginType.phoneLabel": "手機",
  "pages.login.email.placeholder": "請輸入郵箱",
  "pages.login.email.required": "請輸入郵箱",
  "pages.login.email.invalid": "請輸入有效的郵箱地址",
  "pages.login.phone.placeholder": "請輸入手機號",
  "pages.login.phone.required": "請輸入手機號",
  "pages.login.phone.invalid": "請輸入有效的手機號",
  "pages.login.password.placeholder": "請輸入密碼",
  "pages.login.errorMessage.email": "郵箱或密碼錯誤",
  "pages.login.errorMessage.phone": "手機號或密碼錯誤",
  "pages.login.pageTitle": "登錄頁 - No.1 Hoops 管理系統",
  "pages.welcome.link": "歡迎使用",
  "pages.welcome.alertMessage": "更快更強的重型組件，已經發布。",
  "pages.404.subTitle": "抱歉，您訪問的頁面不存在。",
  "pages.404.buttonText": "返回首頁",
  "pages.admin.subPage.title": "這個頁面只有 admin 權限才能查看",
  "pages.admin.subPage.alertMessage":
    "umi ui 現已發佈，歡迎使用 npm run ui 啓動體驗。",
  "pages.searchTable.createForm.newRule": "新建規則",
  "pages.searchTable.updateForm.ruleConfig": "規則配置",
  "pages.searchTable.updateForm.basicConfig": "基本信息",
  "pages.searchTable.updateForm.ruleName.nameLabel": "規則名稱",
  "pages.searchTable.updateForm.ruleName.nameRules": "請輸入規則名稱！",
  "pages.searchTable.updateForm.ruleDesc.descLabel": "規則描述",
  "pages.searchTable.updateForm.ruleDesc.descPlaceholder": "請輸入至少五個字符",
  "pages.searchTable.updateForm.ruleDesc.descRules":
    "請輸入至少五個字符的規則描述！",
  "pages.searchTable.updateForm.ruleProps.title": "配置規則屬性",
  "pages.searchTable.updateForm.object": "監控對象",
  "pages.searchTable.updateForm.ruleProps.templateLabel": "規則模板",
  "pages.searchTable.updateForm.ruleProps.typeLabel": "規則類型",
  "pages.searchTable.updateForm.schedulingPeriod.title": "設定調度週期",
  "pages.searchTable.updateForm.schedulingPeriod.timeLabel": "開始時間",
  "pages.searchTable.updateForm.schedulingPeriod.timeRules": "請選擇開始時間！",
  "pages.searchTable.titleDesc": "描述",
  "pages.searchTable.ruleName": "規則名稱爲必填項",
  "pages.searchTable.titleCallNo": "服務調用次數",
  "pages.searchTable.titleStatus": "狀態",
  "pages.searchTable.nameStatus.default": "關閉",
  "pages.searchTable.nameStatus.running": "運行中",
  "pages.searchTable.nameStatus.online": "已上線",
  "pages.searchTable.nameStatus.abnormal": "異常",
  "pages.searchTable.titleUpdatedAt": "上次調度時間",
  "pages.searchTable.exception": "請輸入異常原因！",
  "pages.searchTable.titleOption": "操作",
  "pages.searchTable.config": "配置",
  "pages.searchTable.subscribeAlert": "訂閱警報",
  "pages.searchTable.title": "查詢表格",
  "pages.searchTable.new": "新建",
  "pages.searchTable.chosen": "已選擇",
  "pages.searchTable.item": "項",
  "pages.searchTable.totalServiceCalls": "服務調用次數總計",
  "pages.searchTable.tenThousand": "萬",
  "pages.searchTable.batchDeletion": "批量刪除",
  "pages.searchTable.batchApproval": "批量審批",
  // 總覽頁面
  "pages.welcome.title": "總覽",
  "pages.welcome.todayOpenCount": "今日開門次數",
  "pages.welcome.todayCloseCount": "今日關門次數",
  "pages.welcome.todayMemberCount": "今日來過會員數",
  "pages.welcome.openStatistics": "開門數據統計",
  "pages.welcome.period.week": "週",
  "pages.welcome.period.month": "月",
  "pages.welcome.chart.openCount": "開門次數",
  "pages.welcome.chart.times": "次",
  // 會員訪問歷史頁面
  "pages.memberAccessHistory.title": "會員訪問歷史",
  "pages.memberAccessHistory.column.date": "日期",
  "pages.memberAccessHistory.column.memberId": "會員ID",
  "pages.memberAccessHistory.column.memberName": "會員姓名",
  "pages.memberAccessHistory.column.memberPhone": "手機號",
  "pages.memberAccessHistory.column.memberEmail": "郵箱",
  "pages.memberAccessHistory.column.anomalyCount": "異常次數",
  "pages.memberAccessHistory.column.action": "操作",
  "pages.memberAccessHistory.column.viewDetail": "查看詳情",
  "pages.memberAccessHistory.column.selectDate": "請選擇日期",
  "pages.memberAccessHistory.detail.title": "會員訪問詳情",
  "pages.memberAccessHistory.detail.column.time": "時間",
  "pages.memberAccessHistory.detail.column.action": "動作",
  "pages.memberAccessHistory.detail.column.status": "狀態",
  "pages.memberAccessHistory.detail.column.operator": "操作人",
  "pages.memberAccessHistory.detail.column.countDeducted": "扣減次數",
  "pages.memberAccessHistory.detail.action.open": "開門",
  "pages.memberAccessHistory.detail.action.close": "關門",
  "pages.memberAccessHistory.detail.status.success": "成功",
  "pages.memberAccessHistory.detail.status.failed": "失敗",
  "pages.memberAccessHistory.detail.operator.user": "用戶",
  "pages.memberAccessHistory.detail.operator.member": "會員",
  "pages.memberAccessHistory.detail.operator.unknown": "未知",
  // 會員管理頁面
  "pages.members.title": "會員列表",
  "pages.members.column.id": "ID",
  "pages.members.column.name": "姓名",
  "pages.members.column.phone": "手機號",
  "pages.members.column.email": "郵箱",
  "pages.members.column.address": "地址",
  "pages.members.column.status": "狀態",
  "pages.members.column.createdAt": "創建時間",
  "pages.members.column.action": "操作",
  "pages.members.column.remark": "備註",
  "pages.members.column.tip.memberId": "會員ID",
  "pages.members.status.pending": "待審核",
  "pages.members.status.active": "激活",
  "pages.members.status.inactive": "禁用",
  "pages.members.action.activate": "激活",
  "pages.members.action.edit": "編輯",
  "pages.members.action.delete": "刪除",
  "pages.members.action.confirm.activate": "確定要激活這個會員嗎？",
  "pages.members.action.confirm.activateDesc": "激活後會員將可以使用系統功能",
  "pages.members.action.confirm.delete": "確定要刪除這個會員嗎？",
  "pages.members.action.confirm.ok": "確定",
  "pages.members.action.confirm.cancel": "取消",
  "pages.members.placeholder.selectStatus": "請選擇狀態",
  // 用戶管理頁面
  "pages.users.title": "用戶列表",
  "pages.users.column.id": "ID",
  "pages.users.column.email": "郵箱",
  "pages.users.column.phone": "手機號",
  "pages.users.column.name": "姓名",
  "pages.users.column.role": "角色",
  "pages.users.column.status": "狀態",
  "pages.users.column.createdAt": "創建時間",
  "pages.users.column.action": "操作",
  "pages.users.column.tip.userId": "用戶ID",
  "pages.users.role.admin": "管理員",
  "pages.users.role.editor": "編輯",
  "pages.users.role.viewOnly": "查看",
  "pages.users.status.active": "激活",
  "pages.users.status.inactive": "禁用",
  "pages.users.action.edit": "編輯",
  "pages.users.action.delete": "刪除",
  "pages.users.action.confirm.delete": "確定要刪除這個用戶嗎？",
};
